import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'
import { Row, Col } from 'react-flexbox-grid'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import * as courseSelectors from 'services/courses/selectors'
import * as courseActions from 'services/courses/actions'
import * as user from 'services/user/selectors'
import styles from './_recentCourses.css'
import RouteThumb from 'components/home/shared/RouteThumb'

const mapStateToProps = (state) => ({
  userId: user.selectUserId(state),
  courses: courseSelectors.selectCourses(state),
  noCourses: courseSelectors.selectNoCoursesFound(state),
})

const mapDispatchToActions = {
  ...courseActions,
}

export class RecentCourses extends Component {
  static propTypes = {
    userId: PropTypes.number,
    getUserCourses: PropTypes.func,
    courses: PropTypes.array,
    noCourses: PropTypes.bool,
  }

  componentWillMount () {
    const { userId, getUserCourses } = this.props
    getUserCourses(userId, 4)
  }

  render () {
    const { courses, noCourses } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h3 className={styles.headerText}>
            <FormattedMessage id='home.dashboard.recentcourses' defaultMessage='Recent Courses' />
          </h3>
          <Link className={styles.viewAll} to='/routes/my_routes/courses'>
            <FormattedMessage id='home.dashboard.recentcourses.view' defaultMessage='View All' />
          </Link>
        </div>
        {noCourses ?
          <FormattedMessage id='home.dashboard.recentcourses.404' defaultMessage='No courses found.' />
        : null}
        <Row>
          {courses.map((course, i) => {
            return (
              <Col key={i} xs={3}>
                <RouteThumb route={course} isCourse={true} />
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(RecentCourses)



// WEBPACK FOOTER //
// ./src/components/home/courses/RecentCourses.jsx